/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Account')
    .factory('editNotificationShare', ['$rootScope', '$modal', '$translate', function ($rootScope, $modal, $translate) {

            return {
                showDialog: function (share) {
                    var modalInstance = $modal.open({
                        domOptions: {
                            modalTitle: $translate.instant("Notifications for '%{node_name}'", { node_name: share.name }),
                            modalType: 'notify',
                            modalActionButton: $translate.instant('Save & Close'),
                            modalBodyTemplate: 'account/edit_notification_share'
                        },
                        controller: 'NotificationShareModalController',
                        resolve: {
                            share: function () {
                                return share;
                            }
                        }
                    });

                    modalInstance.result.then(function (response) {
                        switch (response) {
                            case 'reload_shares':
                                $rootScope.$broadcast('reload_shares');
                                break;
                        }
                    });
                }
            }
    }]);